import { Detect } from "../internal/Detect"

/** `window`, or `undefined` where the environment has none (absent in workers and node). */
export const GetWindow = (): Window | undefined => Detect("window")
